/* Search Functions */
((seach) => {
    const searchInput       = document.getElementById('searchInput')
    const beforeSearchInput = document.getElementById('beforeSearchInput')
    const openSearchBox     = document.getElementById('openSearchBox')
    
    beforeSearchInput.addEventListener('keydown', (evt)=>{
        let searchLength = evt.target.value.length;
        if(searchLength >= 3){
            openSearchBox.dispatchEvent(new Event('click'));
            searchInput.value = evt.target.value;
            searchInput.dispatchEvent(new Event('keypress'));
            evt.target.value = '';
        }
    })
})()
/* End of Search Functions */

/* Carrousel for Logo List Store  */

    const textRowCarrousel = $('.logo-list-store-container');
    if(textRowCarrousel != null){
        textRowCarrousel.slick({
            dots: false,
            infinite: false,
            speed: 300,
            slidesToShow: 4,
            slidesToScroll: 1,
            responsive: [
                {
                    breakpoint: 737,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1
                    }
                }
            ]
        })
    }

/* End of Logo List Store */ 


const featuredCollection = $('.featured-collection__products');
if(featuredCollection != null){
    featuredCollection.slick({
        arrows: true,
        dots: false,
        infinite: false,
        speed: 300,
        slidesToShow: 4,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 737,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }
        ]
    })
}

const blogsStore = $('#shopify-section-blog-posts-store .cont');
    if(blogsStore != null){
        blogsStore.slick({
            infinite: false,
            speed: 300,
            slidesToShow: 3,
            slidesToScroll: 1,
            responsive: [
                {
                    breakpoint: 767,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1
                    }
                }
            ]
        });
}

function jsSectionServiceV1Slick(){
    $('#shopify-section-servicebox-store .input-group').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: false,
        dots: false,
        mobileFirst: true,
        responsive: [
            {
                breakpoint: 767,
                settings: "unslick"
            }
        ]
    });
}

$(document).ready(function() {
    jsSectionServiceV1Slick();
    setTimeout(function(){ 
        recomendationCarrouselFun();
    }, 500);    
    window.addEventListener('resize', function () { 
        if(window.innerWidth < 768) {
            jsSectionServiceV1Slick();
        }
    });
});

/* Certificaciones Carrousel only in Product Certificaciones (MOBILE) */
function recomendationCarrouselFun() {
    const recomendationCarrousel = $('.product-recommendations .grid--uniform');
    if(recomendationCarrousel != null){
        recomendationCarrousel.slick({
            infinite: false,
            arrows: true,
            speed: 300,
            slidesToShow: 5,
            slidesToScroll: 1,
            responsive: [
                {
                    breakpoint: 767,
                    settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                    }
                }
            ]
        })
    }
}